export default "__VITE_ASSET__DKCl34q$__"